// extracted by mini-css-extract-plugin
module.exports =  {"contact":"_93444fe79c--contact--nFJ50","logo":"_93444fe79c--logo--b2tKx","text":"_93444fe79c--text--vQTSJ","button":"_93444fe79c--button--nnpsa"};